module.exports = {
  POST_api_auth_signup: "https://api.advisingbuddy.com/api/auth/signup",
  POST_api_auth_signin: "https://api.advisingbuddy.com/api/auth/signin",
  
  //user login api for email and password
  POST_API_USER_LOGIN:"https://api.advisingbuddy.com/api/auth/validate/user",
  
  // this requireand otp user type.
  POST_OTP_VALIDATION_URL: "https://api.advisingbuddy.com/api/auth/authenticate/otp",

  //resend requires useremail and role of the user.
  POST_RESEND_OTP_URL: "https://api.advisingbuddy.com/api/auth/resend/otp",

  //requires to post the email of the user.
  POST_FORGET_PASSWORD_URL: "https://api.advisingbuddy.com/api/auth/forgot/password",

  // need to post email , new password, confirm password.
  POST_CHANGE_PASSWORD_URL: "https://api.advisingbuddy.com/api/auth/change/password",

  //Getting the user information
  GET_USER_PROFILE_URL: "https://api.advisingbuddy.com/useremail",

  //Payment creating order
  POST_PAY_CREATE_ORDER: "https://api.advisingbuddy.com/public/pay/create/order",

  //GET public profile information(public page)
  GET_USER_PROFILE_INFORMATION:
    "https://api.advisingbuddy.com/public/profile?username=", //need to add the ?username=dynamic name

  //For Time Slots
  POST_AVAILABLE_TIME_SLOT:
    "https://api.advisingbuddy.com/public/available/time/slots",

  //POST for create booking.
  POST_SERVICE_BOOKING: "https://api.advisingbuddy.com/public/service/booking/create",

  POST_USER_AVAILABLE_TIME_SLOT:
    "https://api.advisingbuddy.com/public/available/time/slots",

  //related payment
  POST_PAYMENT_PAY_RESPONSE: "https://api.advisingbuddy.com/public/pay/response",

  POST_SERVICE_ADD: "https://api.advisingbuddy.com/advisor/dashboard/service/add",

  //POST TOGGLE BUTTON
  POST_TOGGLE_VALUE: "https://api.advisingbuddy.com/advisor/dashboard/service/toggle",

  //GET ALL THE SERVICE
  GET_ALL_SERVICE: "https://api.advisingbuddy.com/advisor/dashboard/service",

  //DELETE THE SERVICE
  DELETE_SERVICE_URL:
    "https://api.advisingbuddy.com/advisor/dashboard/service/delete",

  //GET SERVICE LIST BY TYPE
  GET_SERVICE_BY_USERNAME_AND_TYPE:
    "https://api.advisingbuddy.com/advisor/dashboard/service",

  // GET SERVICE INFORMATION USING USERNAME AND IT"S PLATFORMSERVICEID
  GET_SERVICE_BY_USERNAME_AND_PLATFORMSERVICEID:
    "https://api.advisingbuddy.com/public/service/", // PLATFORMID + ?username = "username"
  //Updating service id
  PUT_SERVICE_BY_SERVICE_ID:
    "https://api.advisingbuddy.com/advisor/dashboard/service/update/",

  //CREATE_QUERY
  POST_QUERY_TO_ADVISOR: "https://api.advisingbuddy.com/public/service/query/create",

  //RESPONSE_FOR_QUERY
  PUT_RESPONSE_QUERY:
    "https://api.advisingbuddy.com/advisor/dashboard/query/response",

  //EDIT RESPONSE FOR QUERY
  POST_EDIT_RESPONSE_QUERY:
    "https://api.advisingbuddy.com/advisor/dashboard/query/edit",

  //PROFILE DETAILS ON USERPARAMS
  GET_PROFILE_DETAILS: "https://api.advisingbuddy.com/advisor/dashboard/profile/",

  //GET_ALL_QUERY
  GET_ALL_QUERIES: "https://api.advisingbuddy.com/advisor/dashboard/query/get/all/",

  //GET PENDING QUERIES
  GET_PENDING_QUERIES:
    "https://api.advisingbuddy.com/advisor/dashboard/query/get/pending/",

  //GET PENDING QUERIES
  GET_COMPLETED_QUERIES:
    "https://api.advisingbuddy.com/advisor/dashboard/query/get/completed/",

  //PROFILE SECTION API DASHBOARD//
  PUT_UPDATE_PROFILE_DETAILS:
    "https://api.advisingbuddy.com/advisor/dashboard/profile/update",

  //AVAILABILITY SECTION API HERE//
  GET_AVAILABILITY_DETAILS:
    "https://api.advisingbuddy.com/advisor/dashboard/availability/get/",

  UPDATE_AVAILABILITY_DETAILS:
    "https://api.advisingbuddy.com/advisor/dashboard/availability/update/",

 //availability config API
  GET_CONFIG_DETAILS:
  "https://api.advisingbuddy.com/advisor/dashboard/availability/get/configs/",
  
   //availability update config API
  GET_CONFIG_UPDATE_DETAILS:
  "https://api.advisingbuddy.com/advisor/dashboard/availability/update/configs/",
  
  //Calls section here
  GET_ALL_CALLS: "https://api.advisingbuddy.com/advisor/dashboard/calls/all/",

  //GET_PENDING_CALLS:
  GET_PENDING_CALLS: "https://api.advisingbuddy.com/advisor/dashboard/calls/pending/",

  //GET_COMPLETED_CALLS:
  GET_COMPLETED_CALLS:
    "https://api.advisingbuddy.com/advisor/dashboard/calls/completed/",

  //Mark_AS_Complete_CALL:
  POST_MARK_AS_COMPLETED:
    "https://api.advisingbuddy.com/advisor/dashboard/calls/mark/completed/",

  //Delete Call :
  DELETE_CALL_SERVICE:
    "https://api.advisingbuddy.com/advisor/dashboard/calls/cancel/",

  //Rescedule call:
  RESCHEDULE_CALL:
    "https://api.advisingbuddy.com/advisor/dashboard/calls/re-schedule",

  //GET ALL TRANSACTIONS:
  GET_ALL_TRANSACTIONS_DETAILS:
    "https://api.advisingbuddy.com/advisor/dashboard/payment/get/all/transactions/",

  //GET_ALL_WITHDRAWAL_TRANSACTIONS_DETAILS:
  GET_ALL_WITHDRAWALS_DETAILS:
    "https://api.advisingbuddy.com/advisor/dashboard/payment/withdrawal/all/",

  //GET_ALL_SERVICE_BOOKINGS:
  GET_ALL_SERVICE_BOOKINGS_DETAILS:
    "https://api.advisingbuddy.com/advisor/dashboard/payment/get/bookings/",
    
  //Landing Page Post API Call
  POST_USER_ON_LANDINGPAGE: 'https://api.advisingbuddy.com/public/land',

  //Landing page category API call
  POST_CATEGORY_ON_LANDINGPAGE: 'https://api.advisingbuddy.com/public/category',

  //Landing page search API call
  POST_SEARCH_ON_LANDINGPAGE : 'https://api.advisingbuddy.com/public/search/suggestion?query=',

  //Login with google API call
  Post_LOGIN_WITH_GOOGLE : 'https://api.advisingbuddy.com/api/auth/google/login',

  PRESIGNED_URL: "https://api.advisingbuddy.com/advisor/dashboard/profile/presigned/url",
SAVE_PROFILE_IMAGE: "https://api.advisingbuddy.com/advisor/dashboard/profile/image/url/update",

};
